import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { Setting } from 'src/app/models/setting.model';

import { getLocalTranslate }  from 'src/app/helpers/global-functions'
import { SharedService } from 'src/app/services/shared.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  setting:Setting = new Setting()

  home:string = 'Home'
  contactUs:string = 'Contact Us'
  emailHere:string = 'Email Here'
  ourLocation:string = 'Our Location'
  callHere:string = 'Call Here'
  dropUsMessage:string = 'Drop us Message for any Query'
  yourName:string = 'Your Name'
  yourEmail:string = 'Your Email'
  yourPhone:string = 'Your Phone'
  yourSubject:string = 'Your Subject'
  yourMessage:string = 'Your Message'
  sendMessage:string = 'Your Message'

  constructor(
    private homeService:HomeService,
    private sharedService:SharedService,
    private titleService:Title
  ) { }

  ngOnInit(): void {
    this.getSetting()
    this.needTranslate()

    const id = '4N9IfdQNOh7kwoAlwcdn';
    this.sharedService.getBanner(id).then(result=>{
      const imageUrl = result.image.fileUrl;
      document.getElementById('bg-cover').style.backgroundImage = 'url(' + imageUrl + ')';
    })

  }

  getSetting(){
    this.homeService.getSetting().then(result=>{
      this.setting = result as Setting
    })
  }

  needTranslate(){
    this.home = getLocalTranslate('home',this.home)
    this.contactUs = getLocalTranslate('contact-us',this.contactUs)
    this.emailHere = getLocalTranslate('email-here',this.emailHere)
    this.ourLocation = getLocalTranslate('our-location',this.ourLocation)
    this.callHere = getLocalTranslate('call-here',this.callHere)
    this.dropUsMessage = getLocalTranslate('drop-us-message',this.dropUsMessage)
    this.yourName = getLocalTranslate('your-name',this.yourName)
    this.yourEmail = getLocalTranslate('your-email',this.yourEmail)
    this.yourPhone = getLocalTranslate('your-phone',this.yourPhone)
    this.yourSubject = getLocalTranslate('your-subject',this.yourSubject)
    this.yourMessage = getLocalTranslate('your-message',this.yourMessage)
    this.sendMessage = getLocalTranslate('send-message',this.sendMessage)
    this.titleService.setTitle(`${getLocalTranslate('contact-us',this.contactUs)} | CamEdu`)
  }
}
